import { Report } from '@/slices/reports/reports.types';

export const normalizeReport = (report: Report): Report => {
  if (!report.standard) {
    return report;
  }

  return {
    ...report,
    standard: {
      ...report.standard,
      logoBase64: report.standard.logoBase64 ?? null,
    },
  };
};
